import PopUp from "../components/Nip-Outward-Interaction/PopUp";

const responseHandler2 = (response) => {
    let res = handleResponse(response);
    return res;
}

export default responseHandler2;

function handleResponse(response) {
    const { data, problem, ok } = response;
    let res;
    res = checkResponse(ok, res, problem, data);
    return res;
}

function checkResponse(ok, res, problem, data) {
    if (ok) {
        res = "Request was successful";
        PopUp(true, "success", "Success Message", res);
    } 
    if (problem === "NETWORK_ERROR") {
        res = "Network Error! Kindly try again";
        PopUp(true, "danger", "Error Message", res);
    }
    if (problem === "CLIENT_ERROR") {
       res = data;
       PopUp(data, "danger", "Error Message");
     }
    return res;
}

